import { countries } from '../constants.js/countries';

const GEO_FETCH_TIMEOUT_MS = 8000;

/**
 * Infers country + international dial code from the visitor IP (HTTPS, no GPS permission).
 * Used to prefill signup country selectors.
 *
 * @returns {Promise<{ code: string, phone: string, label: string } | null>}
 */
export async function detectSignupCountryDial() {
    try {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), GEO_FETCH_TIMEOUT_MS);

        const res = await fetch('https://ipapi.co/json/', {
            signal: controller.signal,
            credentials: 'omit',
        });
        window.clearTimeout(timeoutId);

        if (!res.ok) {
            return null;
        }

        const data = await res.json();
        if (data && data.error) {
            return null;
        }

        const iso =
            typeof data.country_code === 'string' ? data.country_code.trim().toUpperCase() : '';

        if (!iso) {
            return null;
        }

        const match = countries.find((c) => c.code === iso);
        return match || null;
    } catch {
        return null;
    }
}
